@let $searchQuery = searchQuery();

<app-page heading="Marketplace" [pageTitle]="pageTitle()">
  <div class="app-row tight gapped app-fill-first">
    <input
      type="text"
      placeholder="Search prompts and packs..."
      [value]="$searchQuery.query"
      (input)="onSearchInput($event)"
    />

    <app-drop-down-button>
      <ng-container buttonContent>
        @switch ($searchQuery.typeFilter) {
          @case ('prompt') {
            <icon type="prompt"/>
            Prompts
          } @case ('pack') {
            <icon type="pack"/>
            Packs
          } @default {
            All
          }
        }
      </ng-container>

      <a (click)="setTypeFilter(null)">All</a>
      <a (click)="setTypeFilter('pack')">Packs</a>
      <a (click)="setTypeFilter('prompt')">Prompts</a>
    </app-drop-down-button>
  </div>

  <div class="scroll-container">
    <app-entity-list [items]="results" [linked]="true"/>
  </div>
</app-page>
